import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "About Us", href: "#about" },
    { label: "Products", href: "#products" },
    { label: "Gallery", href: "#gallery" },
    { label: "Contact", href: "#contact" },
  ];

  const products = [{ label: "Premium Patchouli Oil", href: "#products" }];

  const contactInfo = [
    {
      icon: "📍",
      info: "Makassar, Indonesia",
      link: null,
    },
    {
      icon: "📞",
      info: "+62 821 9359 4444",
      link: "https://wa.me/6282193594444?text=Hello%20PT%20Citra%20Aroma%20Indo%2C%20I%20have%20an%20inquiry%20about%20your%20products.",
    },
    {
      icon: "✉️",
      info: "pt.citraaromaindo@gmail.com",
      link: "mailto:pt.citraaromaindo@gmail.com?subject=Inquiry%20from%20Website&body=Hello%20PT%20Citra%20Aroma%20Indo%2C%0D%0A%0D%0AI%20am%20interested%20in%20your%20products.%20Please%20provide%20more%20information.%0D%0A%0D%0AThank%20you.",
    },
  ];

  const contactInfoIndia = [
    {
      icon: "📍",
      info: "New Town, Kolkata, India",
      link: null,
    },
    {
      icon: "📞",
      info: "+91 800 102 594 3",
      link: "https://wa.me/918001025943?text=Hello%20PT%20Citra%20Aroma%20Indo%2C%20I%20have%20an%20inquiry%20about%20your%20products.",
    },
    {
      icon: "✉️",
      info: "skgasn@gmail.com",
      link: "mailto:skgasn@gmail.com?subject=Inquiry%20from%20Website&body=Hello%20PT%20Citra%20Aroma%20Indo%2C%0D%0A%0D%0AI%20am%20interested%20in%20your%20products.%20Please%20provide%20more%20information.%0D%0A%0D%0AThank%20you.",
    },
  ];

  return (
    <footer
      className="position-relative"
      style={{
        backgroundColor: "#0f2a2b",
        color: "#ffffff",
        padding: "60px 0 20px",
        borderTop: "5px solid #b68b40",
      }}
    >
      {/* Decorative Top Line */}
      <div
        className="position-absolute top-0 start-0 end-0"
        style={{
          height: "5px",
          background: "linear-gradient(90deg, #b68b40, #e8d5b5, #b68b40)",
        }}
      />

      <div className="container">
        {/* Main Footer Content - Responsive Grid */}
        <div className="row g-4 g-lg-5">
          {/* Column 1: Company Info */}
          <div className="col-12 col-lg-6" data-aos="fade-up">
            <div className="pe-lg-4">
              <h3
                className="fw-bold mb-3"
                style={{
                  color: "#e8d5b5",
                  fontSize: "clamp(1.3rem, 3vw, 1.5rem)",
                  letterSpacing: "1px",
                }}
              >
                PT CITRA AROMA INDO
              </h3>

              <p
                className="fst-italic mb-3"
                style={{
                  color: "#e8d5b5",
                  fontSize: "clamp(0.95rem, 2vw, 1rem)",
                }}
              >
                Premium Patchouli Oil Producer
              </p>

              <p
                className="mb-4"
                style={{
                  color: "#adb5bd",
                  fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                  lineHeight: "1.8",
                  maxWidth: "100%",
                }}
              >
                Producing and distributing high-quality patchouli oil for global
                industries. Committed to quality, sustainability, and customer
                trust.
              </p>

              {/* Contact Info with Clickable Links */}
              <div className="d-flex flex-column gap-2 mb-4">
                {contactInfo.map((item, index) => (
                  <div key={index}>
                    {item.link ? (
                      <a
                        href={item.link}
                        target={item.icon === "📞" ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                        className="d-inline-flex align-items-center text-decoration-none"
                        style={{
                          gap: "clamp(8px, 2vw, 10px)",
                          backgroundColor: "rgba(255,255,255,0.05)",
                          padding:
                            "clamp(8px, 2vw, 10px) clamp(12px, 3vw, 18px)",
                          borderRadius: "30px",
                          fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                          color: "#e8d5b5",
                          transition: "all 0.3s ease",
                          border: "1px solid rgba(255,255,255,0.1)",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor =
                            item.icon === "📞" ? "#25D366" : "#b68b40";
                          e.currentTarget.style.color = "white";
                          e.currentTarget.style.transform = "translateY(-3px)";
                          e.currentTarget.style.borderColor = "transparent";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(255,255,255,0.05)";
                          e.currentTarget.style.color = "#e8d5b5";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.borderColor =
                            "rgba(255,255,255,0.1)";
                        }}
                      >
                        <span style={{ fontSize: "clamp(1rem, 2vw, 1.1rem)" }}>
                          {item.icon}
                        </span>
                        <span
                          className="text-truncate"
                          style={{ maxWidth: "200px" }}
                        >
                          {item.info}
                        </span>
                        {item.icon === "📞" && (
                          <span style={{ fontSize: "0.8rem", opacity: 0.8 }}>
                            ↗
                          </span>
                        )}
                      </a>
                    ) : (
                      <div
                        className="d-inline-flex align-items-center"
                        style={{
                          gap: "clamp(8px, 2vw, 10px)",
                          backgroundColor: "rgba(255,255,255,0.05)",
                          padding:
                            "clamp(8px, 2vw, 10px) clamp(12px, 3vw, 18px)",
                          borderRadius: "30px",
                          fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                          color: "#e8d5b5",
                        }}
                      >
                        <span style={{ fontSize: "clamp(1rem, 2vw, 1.1rem)" }}>
                          {item.icon}
                        </span>
                        <span>{item.info}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* ADDRESS INDIA */}
              <p
                className="fst-italic mb-3"
                style={{
                  color: "#e8d5b5",
                  fontSize: "clamp(0.95rem, 2vw, 1rem)",
                }}
              >
                Our Offshore Office:
              </p>

              {/* Contact Info with Clickable Links */}
              <div className="d-flex flex-column gap-2 mb-4">
                {contactInfoIndia.map((item, index) => (
                  <div key={index}>
                    {item.link ? (
                      <a
                        href={item.link}
                        target={item.icon === "📞" ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                        className="d-inline-flex align-items-center text-decoration-none"
                        style={{
                          gap: "clamp(8px, 2vw, 10px)",
                          backgroundColor: "rgba(255,255,255,0.05)",
                          padding:
                            "clamp(8px, 2vw, 10px) clamp(12px, 3vw, 18px)",
                          borderRadius: "30px",
                          fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                          color: "#e8d5b5",
                          transition: "all 0.3s ease",
                          border: "1px solid rgba(255,255,255,0.1)",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor =
                            item.icon === "📞" ? "#25D366" : "#b68b40";
                          e.currentTarget.style.color = "white";
                          e.currentTarget.style.transform = "translateY(-3px)";
                          e.currentTarget.style.borderColor = "transparent";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(255,255,255,0.05)";
                          e.currentTarget.style.color = "#e8d5b5";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.borderColor =
                            "rgba(255,255,255,0.1)";
                        }}
                      >
                        <span style={{ fontSize: "clamp(1rem, 2vw, 1.1rem)" }}>
                          {item.icon}
                        </span>
                        <span
                          className="text-truncate"
                          style={{ maxWidth: "200px" }}
                        >
                          {item.info}
                        </span>
                        {item.icon === "📞" && (
                          <span style={{ fontSize: "0.8rem", opacity: 0.8 }}>
                            ↗
                          </span>
                        )}
                      </a>
                    ) : (
                      <div
                        className="d-inline-flex align-items-center"
                        style={{
                          gap: "clamp(8px, 2vw, 10px)",
                          backgroundColor: "rgba(255,255,255,0.05)",
                          padding:
                            "clamp(8px, 2vw, 10px) clamp(12px, 3vw, 18px)",
                          borderRadius: "30px",
                          fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                          color: "#e8d5b5",
                        }}
                      >
                        <span style={{ fontSize: "clamp(1rem, 2vw, 1.1rem)" }}>
                          {item.icon}
                        </span>
                        <span>{item.info}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Business Hours */}
              <div className="mt-4">
                <h4
                  className="fw-semibold mb-2"
                  style={{
                    color: "#e8d5b5",
                    fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
                  }}
                >
                  Business Hours
                </h4>
                <div
                  style={{
                    color: "#adb5bd",
                    fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                    lineHeight: "1.8",
                  }}
                >
                  <p className="mb-0">Monday - Friday: 08:00 - 17:00</p>
                  <p className="mb-0">Saturday: 08:00 - 13:00</p>
                  <p className="mb-0">Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links & Products */}
          <div
            className="col-12 col-lg-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="row g-4">
              {/* Quick Links */}
              <div className="col-6">
                <h4
                  className="fw-semibold position-relative pb-2 mb-4"
                  style={{
                    color: "#e8d5b5",
                    fontSize: "clamp(1.1rem, 2.5vw, 1.2rem)",
                  }}
                >
                  Quick Links
                  <span
                    className="position-absolute bottom-0 start-0"
                    style={{
                      width: "40px",
                      height: "2px",
                      backgroundColor: "#b68b40",
                    }}
                  />
                </h4>

                <div className="d-flex flex-column gap-2">
                  {quickLinks.map((link, index) => (
                    <a
                      key={index}
                      href={link.href}
                      className="text-decoration-none"
                      style={{
                        color: "#ced4da",
                        transition: "all 0.3s ease",
                        display: "inline-block",
                        fontSize: "clamp(0.9rem, 2vw, 1rem)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.color = "#b68b40";
                        e.target.style.transform = "translateX(8px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = "#ced4da";
                        e.target.style.transform = "translateX(0)";
                      }}
                    >
                      → {link.label}
                    </a>
                  ))}
                </div>
              </div>

              {/* Products */}
              <div className="col-6">
                <h4
                  className="fw-semibold position-relative pb-2 mb-4"
                  style={{
                    color: "#e8d5b5",
                    fontSize: "clamp(1.1rem, 2.5vw, 1.2rem)",
                  }}
                >
                  Our Product
                  <span
                    className="position-absolute bottom-0 start-0"
                    style={{
                      width: "40px",
                      height: "2px",
                      backgroundColor: "#b68b40",
                    }}
                  />
                </h4>

                <div className="d-flex flex-column gap-2">
                  {products.map((product, index) => (
                    <a
                      key={index}
                      href={product.href}
                      className="text-decoration-none"
                      style={{
                        color: "#ced4da",
                        transition: "color 0.3s ease",
                        display: "inline-block",
                        fontSize: "clamp(0.9rem, 2vw, 1rem)",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#b68b40")}
                      onMouseLeave={(e) => (e.target.style.color = "#ced4da")}
                    >
                      • {product.label}
                    </a>
                  ))}
                </div>

                {/* Company Values */}
                <div className="mt-5">
                  <h4
                    className="fw-semibold mb-3"
                    style={{
                      color: "#e8d5b5",
                      fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
                    }}
                  >
                    Our Values
                  </h4>
                  <div
                    style={{
                      color: "#adb5bd",
                      fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                    }}
                  >
                    <p className="mb-1">✓ Quality</p>
                    <p className="mb-1">✓ Sustainability</p>
                    <p className="mb-1">✓ Integrity</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mt-5 pt-4"
          style={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <p
            className="text-center text-md-start mb-0"
            style={{ color: "#adb5bd", fontSize: "clamp(0.8rem, 2vw, 0.9rem)" }}
          >
            © {currentYear} PT Citra Aroma Indo. All rights reserved.
          </p>

          <div className="d-flex gap-4">
            <a
              href="#home"
              className="text-decoration-none"
              style={{
                color: "#adb5bd",
                fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#b68b40")}
              onMouseLeave={(e) => (e.target.style.color = "#adb5bd")}
            >
              Privacy Policy
            </a>
            <a
              href="#home"
              className="text-decoration-none"
              style={{
                color: "#adb5bd",
                fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#b68b40")}
              onMouseLeave={(e) => (e.target.style.color = "#adb5bd")}
            >
              Terms of Service
            </a>
          </div>
        </div>

        {/* Back to Top Button */}
        <a
          href="#home"
          className="position-fixed d-flex align-items-center justify-content-center text-decoration-none"
          style={{
            bottom: "clamp(15px, 3vw, 30px)",
            right: "clamp(15px, 3vw, 30px)",
            width: "clamp(40px, 8vw, 50px)",
            height: "clamp(40px, 8vw, 50px)",
            backgroundColor: "#b68b40",
            borderRadius: "50%",
            color: "white",
            fontSize: "clamp(1.2rem, 3vw, 1.5rem)",
            boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
            transition: "all 0.3s ease",
            zIndex: 1000,
            opacity: 0.8,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#1a3e3f";
            e.currentTarget.style.opacity = "1";
            e.currentTarget.style.transform = "translateY(-5px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#b68b40";
            e.currentTarget.style.opacity = "0.8";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          ↑
        </a>
      </div>
    </footer>
  );
};

export default Footer;
